import fromTheme from './fromTheme';

type Breakpoints = 'sm' | 'md' | 'lg' | 'xlg' | 'xxlg';

const mediaQuery = {
    min: (size: Breakpoints) => fromTheme((theme) => `@media (min-width: ${theme.breakpoints[size]})`),
    max: (size: Breakpoints) => fromTheme((theme) => `@media (max-width: ${theme.breakpoints[size]})`),
};

export default mediaQuery;
